export default "__VITE_ASSET__DewLdoeo__"